export const withOpacity = (hexColor: string, opacity: number) =>
  hexColor +
  Math.round(255 * Math.max(0, Math.min(1, opacity)))
    .toString(16)
    .repeat(2)
    .slice(0, 2);
